import { GiftIdeaContainer } from '@/src/modules/pg-plus/content/recommendations/StyledComponents'
import Card from '@/src/common/components/marketing/cards/Card'
import {
    changeProductEvent,
    clickedRelatedItemEvent,
} from '@/src/common/utilities/gtag'

type TGiftProps = {
    image: string
    description: string
    url: string
    type: 'plastic' | 'virtual'
    brandName: string
}

const GiftIdea = ({ image, description, url, type, brandName }: TGiftProps) => {
    return (
        <GiftIdeaContainer
            href={url}
            onClick={() => {
                changeProductEvent(type)
                clickedRelatedItemEvent('gift idea', `${type} ${brandName}`)
            }}
        >
            <Card
                size={'md'}
                image={image}
                overlayType={'none'}
                isExtended={false}
            />
            <p>{description}</p>
        </GiftIdeaContainer>
    )
}

export default GiftIdea
